/**
 * @page 资产相关store
 * @author qingqing.yang
 * @Date 2018/7/2
 */

import { observable, action, configure, makeAutoObservable } from 'mobx';
import { calc } from '@ok/blade';

import UTIL from '_common/utils/util';

import { StepError, StepNeedErrorCode } from '../constants/StepErrorcode';
import rechargeCoinService from '../service/rechargeCoin';

configure({
  enforceActions: 'always',
});

class rechargeCoinStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      selectCurrency: observable,
      selectNetwork: observable,
      currencyList: observable,
      currencyId: observable,
      currency: observable,
      desAddresses: observable,
      confirm: observable,
      addressStatus: observable,
      needTag: observable,
      reminderMessage: observable,
      tagsMessage: observable,
      fieldStr: observable,
      tagDetail: observable,
      minDeposit: observable,
      info: observable,
      errCode: observable,
      errMsg: observable,
      errData: observable,
      userType: observable,
      page: observable,
      listError: observable,
      rechargeList: observable,
      historyDialogShow: observable,
      addressListErr: observable,
      addressList: observable,
      historyPage: observable,
      showStepPre: observable,
      preStepList: observable,
      showSpecialDialog: observable,
      checkError: observable,
      historyLoading: observable,
      rechargeHistoryLoading: observable,
      isPhoneRegister: observable,
      stableList: observable,
      selectStableId: observable,
      stableCurrency: observable,
      reKycStatus: observable,
      showSenderInfoModal: observable,
      showSuccessDialog: observable,
      changeShowSenderInfoModal: action,
      changeShowSuccessDialog: action,
      submitSenderInfo: action,
      getRechargeCurrencies: action,
      setCurrency: action,
      updateCoin: action,
      updateNetwork: action,
      changeStable: action,
      getRechargeAddress: action,
      getRechargeList: action,
      onPageChange: action,
      getHistoryAddress: action,
      openHistoryDialog: action,
      closeHistoryDialog: action,
      closeSpecialDialog: action,
      getCheckInfo: action,
      clearData: action,
    });

    this.rootStore = rootStore;
  }

  // 币种
  selectCurrency = null; //  下拉框选择币种
  selectNetwork = null;
  currencyList = []; //  可充值币种列表
  currencyId = -1; // 筛选币种的 currencyId
  currency = ''; // 筛选币种的 currency
  desAddresses = []; // 充值地址
  confirm = 0; // 充值到账确认数
  addressStatus = 0; // 地址状态
  needTag = false; // 是否需要特殊标签
  reminderMessage = null; // 是否需要特殊标签
  tagsMessage = {
    tag: null,
    tagsMemo: null,
    tagsMessage: [],
  }; // 新标签

  fieldStr = ''; // 特殊标签 title
  tagDetail = ''; // 特殊标签 值
  minDeposit = 0; // 最小充值数
  info = {
    tips: '',
    alert: '',
  }; // 特殊币种提示信息

  errCode = 0; // 错误码
  errMsg = ''; // 错误信息
  errData = []; // 前置条件
  userType = 0; // 用户身份信息
  page = {
    // 完成订单列表分页信息
    pageIndex: 1, // 当前页码
    pageTotal: '', // 页数
    pageSize: 20, // 每页大小
  };

  listError = ''; // 充值列表接口返回错误信息
  rechargeList = []; // 充值列表
  historyDialogShow = false; // 历史充值地址弹框
  addressListErr = ''; // 历史充值地址 获取失败 错误提示
  addressList = []; // 历史地址列表
  historyPage = {
    // 历史充值地址信息
    pageIndex: 1, // 当前页码
    pageTotal: '', // 页数
    pageSize: 10, // 每页大小
  };

  showStepPre = false; // 用户是否可以充值前置条件
  preStepList = []; // 前置条件列表
  showSpecialDialog = false;
  checkError = '';
  historyLoading = false;
  rechargeHistoryLoading = false;
  isPhoneRegister = false;
  stableList = []; // 稳定币信息列表
  selectStableId = -1; // 稳定币选中的二级币种id
  stableCurrency = ''; // 稳定币种选中的二级币种名称
  reKycStatus = ''; // 再KYC状态
  showSenderInfoModal = false; // 提交sygna附送元的对话框
  showSuccessDialog = false; // 提交sygna附送元成功框的状态

  changeShowSenderInfoModal = (showSenderInfoModal) => {
    this.showSenderInfoModal = showSenderInfoModal;
  };

  changeShowSuccessDialog = (showSuccessDialog) => {
    this.showSuccessDialog = showSuccessDialog;
  };

  submitSenderInfo = (params) => {
    this.onConfirmAddress = true;
    rechargeCoinService
      .fillSenderInfo(params)
      .then(
        action(() => {
          this.showSenderInfoModal = false;
          this.showSuccessDialog = true;
        })
      )
      .catch(
        action(() => {
          // this.confirmAddressErrorCode = res.code;
          // this.confirmAddressError = res.msg;
          // this.onConfirmAddress = false;
        })
      );
  };

  //  获取可充值币种列表
  getRechargeCurrencies({ currencyId, currency } = {}) {
    // this.rootStore.loadingStore.showLoading();
    rechargeCoinService
      .getCurrendies({
        isWithdraw: false,
        withFavorite: true,
        needFilter: false,
      })
      .then(
        action((data) => {
          if (currencyId || currency) {
            const id = Number(currencyId);
            const cur = currency?.toUpperCase();
            data.map((item) => {
              if (item.currency === cur) {
                this.selectCurrency = item;
              } else if (item.currencyId === id) {
                this.selectCurrency = item;
              }
              return item;
            });

            if (this.selectCurrency) {
              this.updateCoin(this.selectCurrency);
            }
          }
          this.rootStore.loadingStore.hideLoading();
          this.currencyList = data;
        })
      )
      .catch(
        action((res) => {
          this.rootStore.loadingStore.hideLoading();
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  }

  // 从外部跳过来的 可充值的币种
  setCurrency(id) {
    this.selectCurrency = this.currencyList.slice().filter((item) => {
      return item.id === id;
    })[0];
  }

  // 更新 选择币种
  updateCoin(value) {
    this.currencyId = value.currencyId;
    this.currency = value.currency;
    this.reminderMessage = value.reminderMessageNew;
    this.tagsMessage = {
      tag: value?.specialField?.fieldStr,
      tagsMemo: value?.specialField?.tagsMemo,
      tagsMessage: value?.specialField?.tagsMessage,
    };
    this.needTag = false;
    this.fieldStr = '';
    this.tagDetail = '';
    this.info.alert = '';
    this.info.tips = '';
    this.stableCurrency = '';
    this.selectStableId = -1;
    this.selectCurrency = value;
    this.stableList = [];
    this.selectNetwork = null;
    if (value.needTag) {
      this.fieldStr = value.specialField.fieldStr;
      this.tagDetail = value.specialField[value.specialField.field];
    }
    if (value.subCurrencies) {
      const subCurrencies = value.subCurrencies.slice();
      // 此处因为后端业务逻辑原因需要屏蔽main子链逻辑 是否永久变更未知
      const network = subCurrencies.find((c) => {
        return c.currencyId === value.currencyId;
      });
      // this.selectNetwork = network || subCurrencies[0];
      const validSubCurrencies = subCurrencies.filter((T) => {
        return T.operationalStatus !== 0;
      });
      this.selectNetwork = validSubCurrencies[0] || network;
    }
    this.getRechargeAddress(0, 0);
    this.rootStore.loadingStore.showLoading();
  }

  updateNetwork(value) {
    this.selectNetwork = value;
    this.getRechargeAddress(0, 0);
  }

  // 切换稳定币
  changeStable(item) {
    this.stableCurrency = item.currency;
    this.selectStableId = item.currencyId;
    this.getRechargeAddress(0, 0, item.currencyId);
    this.rootStore.loadingStore.showLoading();
  }

  // 获取 充值地址
  getRechargeAddress(isCreate, isNew, stableId) {
    const currencyId = this.selectNetwork
      ? this.selectNetwork.currencyId
      : this.currencyId;

    const { masterCurrencyId = '' } = this.selectNetwork;
    rechargeCoinService
      .getAddress({
        currencyId,
        isCreate,
        isNew,
        stableId,
        masterCurrencyId,
        needFilter: false,
      })
      .then(
        action((data) => {
          const {
            addresses,
            confirmNum,
            status,
            needTag,
            reminderMessageNew,
            minDeposit,
            specialField,
            info,
            stableList,
          } = data;
          this.rootStore.loadingStore.hideLoading();
          this.desAddresses = addresses;
          this.confirm = confirmNum;
          this.addressStatus = status;
          this.needTag = needTag;
          this.reminderMessage = reminderMessageNew;
          this.tagsMessage = {
            tagsMessage: specialField?.tagsMessage,
            tagsMemo: specialField?.tagsMemo,
            tag: specialField?.fieldStr,
          };
          this.minDeposit = minDeposit;
          if (needTag && specialField?.fieldStr !== undefined) {
            this.fieldStr = specialField?.fieldStr;
            this.tagDetail = specialField[specialField?.field];
          }
          if (info && info.alert !== undefined) {
            this.info.alert = info.alert;
            this.showSpecialDialog = info.alert.length > 0;
          }
          if (info && info.tips !== undefined) {
            this.info.tips = info.tips;
          }
          if (stableList && stableList.length > 0) {
            this.stableList = stableList;
            if (stableId === undefined || stableId === null) {
              this.selectStableId = stableList[0].currencyId;
              this.stableCurrency = stableList[0].currency;
            }
          }
        })
      )
      .catch(
        action((res) => {
          this.rootStore.loadingStore.hideLoading();
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  }

  // 获取 充值列表
  getRechargeList(currencyId, currentPage) {
    this.rechargeHistoryLoading = true;
    rechargeCoinService
      .getHistory({
        currencyId: currencyId || this.currencyId,
        currentPage,
        pageLength: this.page.pageSize,
      })
      .then(
        action((data) => {
          const { rechargeHistory, total } = data;
          console.log(currencyId, rechargeHistory);
          rechargeHistory.map((item) => {
            return Object.assign(item, {
              showAmount: calc.showFloorTruncation(item.amount),
              showTime: UTIL.formatTimestamp(
                item.lastUpdate,
                'yyyy-MM-dd hh:mm:ss'
              ),
              showSpeed: item.isInnerTransfer
                ? '-/-'
                : `${item.confirmNum}/${item.depositConfirmations}`,
            });
          });
          this.page.pageTotal = Math.ceil(total / this.page.pageSize);
          this.page.pageIndex = currentPage;
          this.rechargeList = rechargeHistory;
          this.rechargeHistoryLoading = false;
        })
      )
      .catch(
        action((res) => {
          this.listError = res.msg;
          this.rechargeHistoryLoading = false;
        })
      );
  }

  // 更新页码 并触发回调函数
  onPageChange(pageObj, page, callback, currencyId) {
    this[pageObj].pageIndex = page;
    if (callback) {
      if (currencyId !== undefined) {
        callback.call(this, currencyId, page);
      } else {
        callback.call(this, page);
      }
    }
  }

  // 获取历史充值地址
  getHistoryAddress(page) {
    this.historyLoading = true;
    rechargeCoinService
      .getHistoryAddress({
        currencyId: this.selectNetwork
          ? this.selectNetwork.currencyId
          : this.currencyId,
        currentPage: page,
        pageLength: this.historyPage.pageSize,
      })
      .then(
        action((data) => {
          this.historyLoading = false;
          const { addressHistory, total } = data;
          addressHistory.map((item) => {
            return Object.assign(item, {
              showTime: UTIL.formatTimestamp(
                item.createDate,
                'yyyy-MM-dd hh:mm:ss'
              ),
            });
          });
          this.historyPage.pageTotal = Math.ceil(
            total / this.historyPage.pageSize
          );
          this.historyPage.pageIndex = page;
          this.addressList = addressHistory;
        })
      )
      .catch(
        action((res) => {
          this.historyLoading = false;
          this.addressListErr = res.msg;
        })
      );
  }

  // 打开 历史充值地址 弹框
  openHistoryDialog() {
    this.historyDialogShow = true;
    this.getHistoryAddress(1);
  }

  // 打开 历史充值地址 弹框
  closeHistoryDialog() {
    this.historyDialogShow = false;
  }

  closeSpecialDialog() {
    this.showSpecialDialog = false;
  }

  // 前置条件 请求
  getCheckInfo() {
    this.rootStore.loadingStore.showLoading();
    rechargeCoinService
      .getCheckInfo()
      .then(
        action(() => {
          this.showStepPre = false;
          this.checkError = '';
        })
      )
      .catch(
        action((res) => {
          if (res.code === StepNeedErrorCode) {
            // 检查用户是否可以充值
            const { conditions, isPhoneRegister, reKycStatus } = res.data;
            this.reKycStatus = reKycStatus;
            this.isPhoneRegister = isPhoneRegister;
            this.showStepPre = true;
            if (reKycStatus === 0 || reKycStatus === 1) {
              conditions.push({
                code: StepError.NEED_REKYC,
                status: reKycStatus,
              });
            }
            this.preStepList = conditions;
          } else {
            this.showStepPre = false;
            this.checkError = res.msg;
          }
          this.rootStore.loadingStore.hideLoading();
        })
      );
  }

  /**
   * 页面注销 清除币种等信息
   */
  clearData = () => {
    this.selectCurrency = null;
    this.selectNetwork = null;
    this.currencyList = [];
    this.fieldStr = '';
    this.tagDetail = '';
    this.info.alert = '';
    this.info.tips = '';
    this.currencyId = -1;
    this.stableList = [];
    this.selectStableId = -1;
    this.stableCurrency = '';
  };

  cleanTagsMessage = () => {
    this.tagsMessage = {
      tag: null,
      tagsMemo: null,
      tagsMessage: [],
    };
  };
}

export default rechargeCoinStore;
